import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SortOrder } from '../../../../api/gen';

export interface ParkingOperatorFilter {
  firstName?: string;
  lastName?: string;
  parkingSpaceId?: string;
  sortBy?: string;
  sortOrder?: SortOrder;
}

@Component({
  selector: 'app-parking-operator-filters',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './parking-operator-filters.component.html',
  styleUrl: './parking-operator-filters.component.scss'
})
export class ParkingOperatorFiltersComponent implements OnInit {
  filterForm: FormGroup;

  sortFields = [
    { key: 'firstName', value: 'firstName', label: 'First Name' },
    { key: 'lastName', value: 'lastName', label: 'Last Name' },
    { key: 'createdAt', value: 'createdAt', label: 'Created Date' },
    { key: 'updatedAt', value: 'updatedAt', label: 'Modified Date' }
  ];

  sortOrders = [
    { key: 'asc', value: SortOrder.Ascending, label: 'Ascending' },
    { key: 'desc', value: SortOrder.Descending, label: 'Descending' }
  ];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ParkingOperatorFiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { filter: ParkingOperatorFilter }
  ) {
    this.filterForm = this.fb.group({
      firstName: [data?.filter?.firstName || ''],
      lastName: [data?.filter?.lastName || ''],
      parkingSpaceId: [data?.filter?.parkingSpaceId || ''],
      sortBy: [data?.filter?.sortBy || ''],
      sortOrder: [data?.filter?.sortOrder || '']
    });
  }

  ngOnInit(): void { }

  clearFilters(): void {
    this.filterForm.reset();
  }

  applyFilters(): void {
    const formValue = this.filterForm.value;
    const filter: ParkingOperatorFilter = {};

    // Only include non-empty values
    if (formValue.firstName?.trim()) {
      filter.firstName = formValue.firstName.trim();
    }
    if (formValue.lastName?.trim()) {
      filter.lastName = formValue.lastName.trim();
    }
    if (formValue.parkingSpaceId?.trim()) {
      filter.parkingSpaceId = formValue.parkingSpaceId.trim();
    }
    if (formValue.sortBy) {
      filter.sortBy = formValue.sortBy;
    }
    if (formValue.sortOrder) {
      filter.sortOrder = formValue.sortOrder;
    }

    this.dialogRef.close(filter);
  }
}
